<template>
  <div>
    <b-container fluid>
      <h1>Set Access Control</h1>

      <b-button v-b-modal.addObjectModal variant="outline-primary">
        <b-icon-plus></b-icon-plus>Add Item
      </b-button>

      <b-modal ref="addObjectModal" id="addObjectModal" hide-footer title="Add Object">
        <b-form @submit="saveObject">
          <b-row class="my-1">
            <b-col sm="3">
              <label for="object">Object Path:</label>
            </b-col>
            <b-col sm="9">
              <b-form-input id="object" v-model="objectName" type="text"></b-form-input>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="3">
              <label for="role">Role:</label>
            </b-col>
            <b-col sm="9">
              <b-form-select
                id="role"
                v-model="roleId"
                value-field="roleId"
                text-field="role"
                :options="roles"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-button variant="outline-primary" type="submit">
            <b-icon-archive-fill></b-icon-archive-fill>Save
          </b-button>
        </b-form>
      </b-modal>

      <b-table
        ref="selectableTable"
        :items="grantedTable.data"
        :fields="grantedTable.fields"
        selectable
        responsive="sm"
        @row-selected="onRowSelected"
      ></b-table>
      <b-button
        variant="outline-primary"
        v-show="markedForAction.length > 0"
        v-on:click="deleteMarked()"
      >
        <b-icon-trash-fill></b-icon-trash-fill>Delete
      </b-button>
    </b-container>
  </div>
</template>

<script>
import { mixins } from "../mixins";

export default {
  name: "access",
  data() {
    return {
      objectName: "/api/1.0/secure/",
      roleId: null,
      roles: null,
      grantedTable: {
        fields: [
          { key: "role", sortable: true },
          { key: "objectName", sortable: true },
          { key: "description", sortable: false }
        ],
        data: []
      },
      markedForAction: []
    };
  },
  mixins: [mixins],
  created() {
    this.loadAccess();
  },
  methods: {
    saveObject() {
      this.api.
        post('/secure/addObject',{ params: {
          roleId: this.roleId,
          objectName: this.objectName
        }}).
        then(() => {
          this.hideModal();
          this.successToast('Added Object!')
          this.objectName = "/api/1.0/secure/";
          this.loadAccess();
        }).
        catch((error) => {
          this.errorToast(error.message || error.response.data.message || "")
        })      
    },
    onRowSelected(item) {
      this.markedForAction = item;
    },
    hideModal() {
      this.$refs["addObjectModal"].hide();
    },
    deleteMarked() {
      let toDelete = [];
      this.markedForAction.forEach(rec => {
        toDelete.push({
          id: rec.roleId,
          object: rec.objectName
        });
      });
      this.api
        .post("/secure/deleteObjects", { records: toDelete })
        .then(() => {
          this.$refs.selectableTable.clearSelected();
          this.loadAccess();
        })
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    loadAccess() {
      this.api
        .get("/secure/access")
        .then(response => {
          this.roles = response.data.roles;
          this.grantedTable.data = response.data.granted;
        })
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    }
  }
};
</script>

<style scoped></style>
